import * as actionType from "./ActionTypes";


export default function ContainerswaprowdataReducer(state = {}, action) {
    const { payload } = action;
    switch (action.type) {
      case actionType.CONTAINER_SWAP_ROW_DATA:
        return (state = payload);  
        default :
        return state
}
}
